module.exports = __webpack_public_path__ + "static/media/cha_bboki_B.b330e9fe.svg";